import {
    Box, HStack, Input, Button, Table, Thead, Tbody, Tr, Th, Td, Text, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Flex, Image, Heading,
    Alert,
    AlertIcon,
    AlertTitle,
    List,
    ListItem,
    ListIcon,
    OrderedList,
    UnorderedList,
    Textarea,
    Stack,
    VStack,
    Select,
    Link,
    Progress,
    useToast, Accordion, AccordionItem, AccordionButton, AccordionIcon, AccordionPanel,
} from '@chakra-ui/react';
import { FaCopy } from 'react-icons/fa';
import { getLogsEstoqueTaga } from "../services/api";
import { useState, useEffect } from "react";
import Preloader from "../components/Preloader";
import PreloaderMini from "../components/PreloaderMini";
import { formatDistanceToNow, parse, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { FiPlus, FiMinus } from 'react-icons/fi';
import { FaSearch } from 'react-icons/fa';
import ScrollToTop from "../components/ScrollToTop";
import { useUsuarios, semBloqueados } from "../hooks/useUsuarios";

const GestaoEstoque = () => {
    const [loading, setLoading] = useState(false);
    const [loadingMini, setLoadingMini] = useState(false);
    const [loadingLinear, setLoadingLinear] = useState(false);
    const [logs, setLogs] = useState([]);
    const [buscaBool, setBuscaBool] = useState(false);
    const [pagina, setPagina] = useState(1);
    const [ultimaPagina, setUltimaPagina] = useState(1);
    const [totalRegistros, setTotalRegistros] = useState(0);
    const [paginateFrom, setPaginateFrom] = useState(0);
    const [paginateTo, setPaginateTo] = useState(0);
    var consultaLogs = false;
    const toast = useToast()
    const hoje = new Date().toISOString().split('T')[0];

    var dataAtual = new Date();
    var ano = dataAtual.getFullYear();
    var mes = String(dataAtual.getMonth() + 1).padStart(2, '0');
    var dia = String(dataAtual.getDate()).padStart(2, '0');
    var dataFormatadaInicial = `${ano}-${mes}-${dia}`;

    const [filtroId, setFiltroId] = useState("");
    const [filtroAcao, setFiltroAcao] = useState("");
    const [filtroUsuario, setFiltroUsuario] = useState("");
    const usuarios = useUsuarios();
    const [filtroDataInicial, setFiltroDataInicial] = useState("");
    const [filtroDataFinal, setFiltroDataFinal] = useState("");

    useEffect(() => {
        if (consultaLogs == false) {
            consultarLogs(1);
            consultaLogs = true;
        }
    }, []);

    const handleAnterior = () => {
        let paginaAux = pagina - 1;
        if (paginaAux > 1) {
            setPagina(paginaAux);
        } else {
            setPagina(1);
        }
        consultarLogs(paginaAux);
    }

    const handleProxima = () => {
        let paginaAux = pagina + 1;
        setPagina(paginaAux);
        consultarLogs(paginaAux);
    }

    const handlePrimeira = () => {
        setPagina(1);
        consultarLogs(1);
    }

    const handleUltima = () => {
        setPagina(ultimaPagina);
        consultarLogs(ultimaPagina);
    }

    const handleChangeFiltroId = (event) => {
        setFiltroId(event.target.value);
    };

    const handleChangeFiltroAcao = (event) => {
        setFiltroAcao(event.target.value);
    };

    const handleChangeFiltroUsuario = (event) => {
        setFiltroUsuario(event.target.value);
    };

    const handleChangeFiltroDataInicial = (event) => {
        setFiltroDataInicial(event.target.value);
    };

    const handleChangeFiltroDataFinal = (event) => {
        setFiltroDataFinal(event.target.value);
    };

    const limparFiltros = () => {
        setFiltroId("");
        setFiltroAcao("");
        setFiltroUsuario("");
        setFiltroDataInicial("");
        setFiltroDataFinal("");
    };

    const handlePesquisar = () => {
        setPagina(1);
        consultarLogs(true);
    };

    function consultarLogs(paginaAux) {
        setLoadingLinear(true);
        setLoading(true);
        try {
            (async () => {
                var consulta = "pagina=" + paginaAux + "&idAux=" + filtroId + "&acao=" + filtroAcao + "&usuario=" + filtroUsuario + "&data_inicial=" + filtroDataInicial + "&data_final=" + filtroDataFinal;
                const responseLogs = await getLogsEstoqueTaga(consulta);
                if (responseLogs != false) {
                    setLogs(responseLogs.data);
                    setUltimaPagina(responseLogs.last_page)
                    setTotalRegistros(responseLogs.total);
                    setPaginateFrom(responseLogs.from);
                    setPaginateTo(responseLogs.to);
                    setBuscaBool(false);
                } else {
                    setLogs([]);
                    setBuscaBool(true);
                }
                setLoadingLinear(false);
                setLoading(false);
            })();
        }
        catch {
            setLoadingLinear(false);
            setLoading(false);
            return false;
        }
    }

    const formataCreatedAt = (data) => {
        const options = {
            timeZone: 'America/Sao_Paulo',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        };
        return new Date(data).toLocaleString('pt-BR', options);
    }

    const getImgUser = (usuario_id) => {
        var img = "taga_logo.jpg";
        if (usuario_id == 3) {
            img = "/gabriel_logo.webp";
        } else if (usuario_id == 5) {
            img = "/tilio_logo.webp";
        } else if (usuario_id == 6) {
            img = "/riccioppo_logo.webp";
        } else if (usuario_id == 7) {
            img = "/user.png";
        } else if (usuario_id == 8) {
            img = "/gabriel_valiente_logo.webp";
        } else if (usuario_id == 9) {
            img = "/emerson_vendedor_logo.webp";
        } else if (usuario_id == 10) {
            img = "/analuiza_logo.webp";
        }


        return img;
    };

    const getNameUser = (usuario_id) => {
        const usuario = usuarios.find((u) => u.id == usuario_id);
        return usuario ? usuario.name : "Sistema";
    };

    // 0 entrada, 1 saida, 2 balanco. O 3 e uma saida antiga da reversao do
    // kanban de devolucoes, e FURO_ESTOQUE_TAGA e so uma marcacao: a peca nao
    // foi achada, mas o saldo nao muda (ja tinha sido baixado na venda).
    // Os dois caiam no "else" e apareciam como BALANÇO, que nenhum dos dois é.
    const getNameAcao = (id) => {
        const acao = String(id);
        if (acao === "0") return "ENTRADA";
        if (acao === "1" || acao === "3") return "SAÍDA";
        if (acao === "FURO_ESTOQUE_TAGA") return "FURO ESTOQUE";
        return "BALANÇO";
    };

    const getColorAcao = (id) => {
        const acao = String(id);
        if (acao === "0") return "green.300";
        if (acao === "1" || acao === "3") return "red.300";
        if (acao === "FURO_ESTOQUE_TAGA") return "orange.300";
        return "blue.300";
    };

    return (
        <>
            <ScrollToTop />
            {loading && <Preloader />}
            <Box textAlign="center" fontSize="xl" py={10} bg="white" minH="100vh">
                <Box textAlign="center" ml={4} mb={0} fontSize="xl">
                    <Text color={"#F68633"} fontWeight={"bold"}>
                        GESTÃO DE ESTOQUE
                    </Text>
                </Box>
                <Box mx={{ base: 1, md: 12, lg: 20 }} mt={0} boxShadow='md' borderRadius="lg" px={0} mb={"10"} pb={2}>
                    <Box mb={16}>
                        <Text fontSize={"16px"} textAlign="start" ml={4} mt={12} color={"#F68633"} fontWeight={"bold"}>
                            FILTROS
                        </Text>
                        <Flex align={"center"} justifyContent={"center"} flexDirection={{ base: "column", md: "row", lg: "row" }}>
                            <Box mr={4} >
                                <Text textAlign="start" ml={4} mt={2} color={"#F68633"} fontSize={"10px"} fontWeight={"bold"}>
                                    ID PRODUTO
                                </Text>
                                <Input
                                    boxShadow='lg'
                                    bg={'white'}
                                    color={"black"}
                                    placeholder=""
                                    w={{ base: "300px", md: "150px", lg: "150px", xl: "180px" }}
                                    _placeholder={{
                                        color: 'black',
                                        opacity: 0.6,
                                    }}
                                    _focus={{
                                        border: 'none',
                                    }}
                                    value={filtroId}
                                    onChange={handleChangeFiltroId}
                                />
                            </Box>
                            <Box mr={4} >
                                <Text textAlign="start" ml={4} mt={2} color={"#F68633"} fontSize={"10px"} fontWeight={"bold"}>
                                    AÇÃO
                                </Text>
                                <Select
                                    w={{ base: "300px", md: "150px", lg: "180px", xl: "180px" }}
                                    ml={2}
                                    value={filtroAcao}
                                    onChange={handleChangeFiltroAcao}
                                    boxShadow='lg'
                                >
                                    <option value="" selected disabled>Selecione</option>
                                    <option value="0">Todos</option>
                                    <option value="1">ENTRADAS</option>
                                    <option value="2">SAÍDAS</option>
                                    <option value="3">BALANÇO</option>
                                </Select>
                            </Box>
                            <Box mr={4} >
                                <Text textAlign="start" ml={4} mt={2} color={"#F68633"} fontSize={"10px"} fontWeight={"bold"}>
                                    USUÁRIO
                                </Text>
                                <Select
                                    w={{ base: "300px", md: "150px", lg: "180px", xl: "180px" }}
                                    ml={2}
                                    value={filtroUsuario}
                                    onChange={handleChangeFiltroUsuario}
                                    boxShadow='lg'
                                >
                                    <option value="" selected disabled>Selecione</option>
                                    <option value="0">Todos</option>
                                    <option value="100">Sistema</option>
                                    {semBloqueados(usuarios).map((usuario) => (
                                        <option key={usuario.id} value={usuario.id}>{usuario.name}</option>
                                    ))}
                                </Select>
                            </Box>
                            <Box mr={4}>
                                <Text textAlign="start" ml={4} mt={2} color={"#F68633"} fontSize={"10px"} fontWeight={"bold"}>
                                    DATA INCIAL
                                </Text>
                                <Input
                                    w={{ base: "300px", md: "150px", lg: "180px", xl: "180px" }}
                                    placeholder="Selecione a data inicial"
                                    type="date"
                                    max={hoje}
                                    value={filtroDataInicial}
                                    onChange={handleChangeFiltroDataInicial}
                                    boxShadow='lg'
                                />
                            </Box>
                            <Box mr={4}>
                                <Text textAlign="start" ml={4} mt={2} color={"#F68633"} fontSize={"10px"} fontWeight={"bold"}>
                                    DATA FINAL
                                </Text>
                                <Input
                                    w={{ base: "300px", md: "150px", lg: "180px", xl: "180px" }}
                                    placeholder="Selecione a data final"
                                    type="date"
                                    max={hoje}
                                    value={filtroDataFinal}
                                    onChange={handleChangeFiltroDataFinal}
                                    boxShadow='lg'
                                />
                            </Box>
                            <Box>
                                <Button
                                    mt={6}
                                    bg={"#01695E"}
                                    color={"white"}
                                    _hover={{ bg: "white", color: "black", transition: 'background 0.8s, color 0.8s' }}
                                    onClick={handlePesquisar}
                                    boxShadow='lg'
                                >
                                    <FaSearch fontSize='12px' boxShadow='lg' />
                                </Button>
                                <Button
                                    mt={6}
                                    ml={2}
                                    bg={"#FF0000"}
                                    color={"white"}
                                    _hover={{ bg: "white", color: "black", transition: 'background 0.8s, color 0.8s' }}
                                    onClick={limparFiltros}
                                    boxShadow='lg'
                                >
                                    X
                                </Button>
                            </Box>
                        </Flex>
                    </Box>
                    {
                        buscaBool && !loading &&
                        <Alert status='warning'>
                            <AlertIcon />
                            <AlertTitle>Nenhum registro encontrado!</AlertTitle>
                        </Alert>
                    }
                    <Box overflowX="auto" mt={10} mx={{ base: "0", sm: "2", md: "6" }}>
                        <Table>
                            <Thead bg={"#bfbdbd"}>
                                <Tr>
                                    <Th px={2} borderColor={"none"} textAlign={"center"} fontSize={{ base: "12px", sm: "12px", md: "14px" }} color="#01695E"></Th>
                                    <Th px={2} borderColor={"none"} textAlign={"center"} fontSize={{ base: "12px", sm: "12px", md: "14px" }} color="#01695E">Usuário</Th>
                                    <Th px={2} borderColor={"none"} textAlign={"center"} fontSize={{ base: "12px", sm: "12px", md: "14px" }} color="#01695E">ID Produto</Th>
                                    <Th px={2} borderColor={"none"} textAlign={"center"} fontSize={{ base: "12px", sm: "12px", md: "14px" }} color="#01695E">Ação</Th>
                                    <Th px={2} borderColor={"none"} textAlign={"center"} fontSize={{ base: "12px", sm: "12px", md: "14px" }} color="#01695E">Origem</Th>
                                    <Th px={2} borderColor={"none"} textAlign={"center"} fontSize={{ base: "12px", sm: "12px", md: "14px" }} color="#01695E">Localização</Th>
                                    <Th px={2} borderColor={"none"} textAlign={"center"} fontSize={{ base: "12px", sm: "12px", md: "14px" }} color="#01695E">Estoque Anterior</Th>
                                    <Th px={2} borderColor={"none"} textAlign={"center"} fontSize={{ base: "12px", sm: "12px", md: "14px" }} color="#01695E">Estoque Atual</Th>
                                    <Th px={2} borderColor={"none"} textAlign={"center"} fontSize={{ base: "12px", sm: "12px", md: "14px" }} color="#01695E">Mensagem</Th>
                                    <Th px={2} borderColor={"none"} textAlign={"center"} fontSize={{ base: "12px", sm: "12px", md: "14px" }} color="#01695E">Data</Th>
                                </Tr>
                            </Thead>
                            <Tbody color={"black"}>
                                {logs && !loading && logs.map((log) => (
                                    <Tr key={log.id}
                                        px={2}
                                        _hover={{
                                            background: "#dbdbdb",
                                            transition: "background 0.4s ease-in"
                                        }}
                                        borderColor="green"
                                        bg={getColorAcao(log.acao)}
                                    >
                                        <Td px={1} borderColor={"white"} fontSize={{ base: "12px", sm: "12px", md: "14px", lg: "14px", xl: "16px" }} textAlign={"center"}>{
                                            <Image
                                                boxShadow='lg'
                                                borderRadius="50%"
                                                src={getImgUser(log.user_id)}
                                                alt={"imagem_user"}
                                                maxW={{ base: "30px", md: "30px", lg: "30px" }}
                                                maxH="30px"
                                            />
                                        }</Td>
                                        <Td px={1} borderColor={"white"} fontSize={{ base: "12px", sm: "12px", md: "14px", lg: "14px", xl: "14px" }} textAlign={"center"}>{getNameUser(log.user_id)}</Td>
                                        <Td px={1} borderColor={"white"} fontSize={{ base: "14px", sm: "14px", md: "14px", lg: "16px", xl: "14px" }} textAlign={"center"} fontWeight={"bold"}>{log.produto_id}</Td>
                                        <Td px={1} borderColor={"white"} fontWeight={"bold"} fontSize={{ base: "14px", sm: "14px", md: "16px", lg: "16px", xl: "16px" }} textAlign={"center"}>{getNameAcao(log.acao)}</Td>
                                        <Td px={1} borderColor={"white"} fontSize={{ base: "10px", sm: "10px", md: "12px", lg: "12px", xl: "14px" }} textAlign={"center"}>{log.origem}</Td>
                                        <Td px={1} borderColor={"white"} fontSize={{ base: "10px", sm: "10px", md: "12px", lg: "12px", xl: "14px" }} textAlign={"center"}>{log.localizacao || "-"}</Td>
                                        <Td px={1} borderColor={"white"} fontSize={{ base: "10px", sm: "10px", md: "12px", lg: "12px", xl: "14px" }} textAlign={"center"}>{log.quantidade_anterior}</Td>
                                        <Td px={1} borderColor={"white"} fontSize={{ base: "10px", sm: "10px", md: "12px", lg: "12px", xl: "14px" }} textAlign={"center"}>{log.quantidade_atual}</Td>
                                        <Td px={1} borderColor={"white"} fontSize={{ base: "10px", sm: "10px", md: "12px", lg: "12px", xl: "12px" }} textAlign={"center"}>{log.mensagem}</Td>
                                        <Td px={1} borderColor={"white"} fontSize={{ base: "10px", sm: "10px", md: "12px", lg: "12px", xl: "14px" }} textAlign={"center"}>{formataCreatedAt(log.created_at)}</Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </Box>
                    <Flex justifyContent={"center"} mt={6}>
                        <Flex flexDirection={"column"}>
                            <Text fontSize={'10px'} fontWeight={"bold"}>
                                Mostrando {logs ? logs.length : 0} de {totalRegistros} registros do {paginateFrom} ao {paginateTo}
                            </Text>
                            <Flex flexDirection={"row"}>
                                {
                                    pagina != 1 ? (
                                        <Button
                                            onClick={() => handlePrimeira()}
                                        >
                                            {"<<"}
                                        </Button>
                                    ) :
                                        (
                                            <Button
                                                bg="gray.300"
                                                disabled>
                                                {"<<"}
                                            </Button>
                                        )
                                }
                                {
                                    pagina > 1 ? (
                                        <Button
                                            onClick={() => handleAnterior()}
                                        >
                                            {"<"}
                                        </Button>
                                    ) :
                                        (
                                            <Button
                                                bg="gray.300"
                                                disabled
                                            >
                                                {"<"}
                                            </Button>
                                        )
                                }
                                <Button disabled>{pagina}</Button>
                                {

                                    pagina < ultimaPagina ? (
                                        <Button
                                            onClick={() => handleProxima()}
                                        >
                                            {">"}
                                        </Button>
                                    ) :
                                        (
                                            <Button
                                                bg="gray.300"
                                                disabled
                                            >
                                                {">"}
                                            </Button>
                                        )
                                }
                                {
                                    pagina != ultimaPagina ? (
                                        <Button
                                            onClick={() => handleUltima()}
                                        >
                                            {">>"}
                                        </Button>
                                    ) :
                                        (
                                            <Button
                                                bg="gray.300"
                                                disabled
                                            >
                                                {">>"}
                                            </Button>
                                        )
                                }

                            </Flex>
                        </Flex>
                    </Flex>
                    {loadingLinear && <Progress mb={0} size='xs' isIndeterminate colorScheme="orange" />}
                </Box>
            </Box>
        </>
    );
};

export default GestaoEstoque;
